import type { ReactNode } from 'react';
import { Icono } from '../../componentes/Icono';
import { Segmentos } from '../../componentes/Segmentos';
import { sumarDias } from '../../logica/horario';
import { diaCorto, lunesDe, relativo, textoSemana } from './logica';

export type Vista = 'dia' | 'semana';

/**
 * El día o la semana que se mira (RV Navegador del diseño: «‹ Hoy · mié 14 oct ⌄ ›», el día se elige tocándolo) y la vista
 * Día · Semana. El marco no deja subirlo a la línea del título (ver el informe): va aquí, encima de la agenda.
 */
export function Barra({ fecha, hoy, vista, movil, onFecha, onVista, children }: { fecha: string; hoy: string; vista: Vista; movil: boolean; onFecha: (f: string) => void; onVista: (v: Vista) => void; children?: ReactNode }) {
    const paso = vista === 'semana' ? 7 : 1;
    const lunes = lunesDe(fecha);
    const contiene = vista === 'semana' ? hoy >= lunes && hoy <= sumarDias(lunes, 6) : fecha === hoy;
    const texto = vista === 'semana' ? textoSemana(lunes) : fecha === hoy ? diaCorto(fecha) : relativo(fecha, hoy);
    return (
        <div className="rv-ag-barra">
            <div className="rv-ag-nav" role="group" aria-label={vista === 'semana' ? 'Semana de la agenda' : 'Día de la agenda'}>
                <button
                    type="button"
                    className="rv-ag-nav__b"
                    aria-label={vista === 'semana' ? 'Semana anterior' : 'Día anterior'}
                    onClick={() => {
                        onFecha(sumarDias(fecha, -paso));
                    }}
                >
                    <Icono nombre="chevron-left" />
                </button>
                <label className="rv-ag-nav__dia">
                    {contiene && <em>{vista === 'semana' ? 'Esta semana' : 'Hoy'}</em>}
                    {contiene && <span aria-hidden="true">·</span>}
                    <span>{texto}</span>
                    <Icono nombre="chevron-down" tamano={14} />
                    <input
                        type="date"
                        aria-label={vista === 'semana' ? 'Semana de la agenda' : 'Día de la agenda'}
                        value={fecha}
                        onChange={(e) => {
                            if (e.target.value !== '') {
                                onFecha(e.target.value);
                            }
                        }}
                    />
                </label>
                <button
                    type="button"
                    className="rv-ag-nav__b"
                    aria-label={vista === 'semana' ? 'Semana siguiente' : 'Día siguiente'}
                    onClick={() => {
                        onFecha(sumarDias(fecha, paso));
                    }}
                >
                    <Icono nombre="chevron-right" />
                </button>
            </div>
            <div className="rv-ag-barra__vista">
                <Segmentos
                    etiqueta="Vista"
                    movil={movil}
                    items={[
                        { etiqueta: 'Día', icono: 'calendar' },
                        { etiqueta: 'Semana', icono: 'calendar-days' },
                    ]}
                    valor={vista === 'semana' ? 1 : 0}
                    onCambio={(i) => {
                        onVista(i === 1 ? 'semana' : 'dia');
                    }}
                />
            </div>
            {children}
        </div>
    );
}
